import {
  STATUS_REPORT_OFF,
  StatusReportTemplateKey,
  type UserStatusReportSelection,
} from "@forgepoint/shared";

/** Display labels for each personal status-report selection. */
export const SELECTION_LABELS: Record<UserStatusReportSelection, string> = {
  [StatusReportTemplateKey.STANDARD]: "Standard — Your Tasks",
  [StatusReportTemplateKey.SALES_REP]: "Sales Rep — My Deals",
  [StatusReportTemplateKey.ESTIMATOR]: "Estimator — My Queue",
  [StatusReportTemplateKey.MANAGER]: "Manager — Deal Acceleration",
  [STATUS_REPORT_OFF]: "Off",
};

/** Returns the compact form of a selection label (the part before the tagline). */
export function selectionShortLabel(
  selection: UserStatusReportSelection,
): string {
  return SELECTION_LABELS[selection].split(" — ")[0];
}
